(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products-section"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  // Handle Intersection for product recommendations
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          // Initialize Slick only after new content is loaded
          initializeCarousel();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  // Function to initialize the Slick carousel
  function initializeCarousel() {
    $('.product-recommendations .carousel__list').slick({
      slidesToShow: 4, // Show 4 products on desktop
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      dots: false,
     
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3, // Show 3 products on tablet
            slidesToScroll: 1,
            arrows: true,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2, // Show 2 product on mobile
            slidesToScroll: 1,
            arrows: true,
            dots: false
          }
        }
      ]
    });
  }

 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-blog-v1"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  // Initialize Slick on the blog content container
  $('.content-blog-v1').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: false
        }
      },
      {
        breakpoint: 1022,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-service-v1"] && !Shopify.designMode) return;
  try {
    

  $(document).ready(function () {
  if (window.location.pathname === "/") {
    var checkExist = setInterval(function () {
      if ($('.js-services-v1').length && $('.js-services-v1').is(':visible')) {
        clearInterval(checkExist);
        
        console.log("Destroying previous Slick instance...");
        $('.js-services-v1').slick('unslick'); // Destroy existing Slick
        
        console.log("Reinitializing Slick...");
        $('.js-services-v1').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 992,
              settings: { slidesToShow: 4 }
            },
            {
              breakpoint: 768,
              settings: { slidesToShow: 1 }
            }
          ]
        });
      }
    }, 500);
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
 $(document).ready(function() {
  $('.section-slideshow-v1 .slick-side-h1').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'linear',
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    adaptiveHeight: true,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true
        }
      }
    ]
  });
});


  } catch(e) { console.error(e); }
})();
})();
